import React from 'react'
import clsx from 'clsx'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getImageSources } from '@/helpers/getImageSources'
import getImageProps from '@/components/atoms/Image/helpers/get-image-props'
import { ImageProps } from './types'

export const Image: React.FC<ImageProps> = ({ fluid = false, fixed, data, options = {}, showMobile, ...rest }) => {
  const desktopClasses = showMobile === false && 'hidden netbook:block'

  if (data?.image?.includes('.svg'))
    return (
      <img
        src={data.image}
        alt={data.alt_tag || ''}
        loading="lazy"
        className={clsx(desktopClasses, rest.imgClassName)}
        width={Number(options.width)}
        height={Number(options.height)}
        title={data.caption || data.title}
        decoding="async"
        {...rest}
      />
    )

  const fixedProps =
    fixed && data
      ? getImageProps(data, {
          smartCrop: true,
          loading: 'lazy',
          ...options
        })
      : null

  const fluidProps =
    fluid && data
      ? getImageProps(data, {
          smartCrop: false,
          loading: 'lazy',
          ...options
        })
      : null

  if (options.width) {
    if (fluidProps) {
      fluidProps.width = options.width
      fluidProps.height = options.width / fluidProps.aspectRatio
    }
    if (fixedProps) fixedProps.width = options.width
  }
  if (options.height) {
    if (fluidProps) fluidProps.height = options.height
    if (fixedProps) fixedProps.height = options.height
  }

  return fixedProps ? (
    <GatsbyImage
      image={{
        ...fixedProps,
        layout: 'fixed',
        images: {
          sources: getImageSources(fixedProps)
        }
      }}
      {...rest}
      alt={data.alt_tag || ''}
      className={clsx(desktopClasses, rest.className)}
      imgClassName={rest.imgClassName}
      title={data.caption || data.title}
      {...rest}
    />
  ) : fluidProps ? (
    <GatsbyImage
      image={{
        ...fluidProps,
        layout: 'fullWidth',
        images: {
          sources: getImageSources(fluidProps)
        }
      }}
      {...rest}
      alt={data.alt_tag || ''}
      className={clsx(desktopClasses, rest.className)}
      imgClassName={clsx('relative', rest.imgClassName)}
      title={data.caption || data.title}
      {...rest}
    />
  ) : null
}
